import React from 'react'
import type { IconDefaultProps } from '../../../models/types'

const HistoryIcon = ({ className, color }: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 19.4 19.401'
      className={className || 'rf-w-4 rf-h-4'}
    >
      <g transform='translate(-77.528 -79.501)'>
        <path
          d='M378.724,244.778a.614.614,0,0,0-1.227,0v3.891l2.453,2.453a.614.614,0,1,0,.868-.868l-2.093-2.093Z'
          transform='translate(-290.737 -159.395)'
          fill={color || '#FFF'}
        />
        <path
          d='M94.055,82.374A9.73,9.73,0,0,0,87.189,79.5a9.544,9.544,0,0,0-6.848,2.8l-.127.127,0-.93a.677.677,0,0,0-.677-.673h0a.677.677,0,0,0-.673.68l.013,2.552a.679.679,0,0,0,.673.673l2.552.013a.677.677,0,0,0,.007-1.354l-.93,0,.128-.128a8.2,8.2,0,0,1,5.884-2.408,8.457,8.457,0,0,1,8.392,8.4,8.238,8.238,0,0,1-8.3,8.3,8.44,8.44,0,0,1-8.318-9.575.678.678,0,0,0-.579-.762.688.688,0,0,0-.093-.006.677.677,0,0,0-.669.585A9.806,9.806,0,0,0,87.27,98.9h.051a9.591,9.591,0,0,0,9.607-9.658A9.73,9.73,0,0,0,94.055,82.374Z'
          fill={color || '#FFF'}
        />
      </g>
    </svg>
  )
}

export default HistoryIcon
